import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { Box, useMediaQuery, useTheme } from '@mui/material';

export const DASHBOARD_TOOLBAR_ACTIONS_ID = 'dashboard-toolbar-actions';

const actionRowSx = {
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 0.75,
};

export default function DashboardToolbarPortal({ active = true, children, fallbackSx = null, order = 0 }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [container, setContainer] = useState(null);

  useLayoutEffect(() => {
    setContainer(document.getElementById(DASHBOARD_TOOLBAR_ACTIONS_ID));
  }, []);

  if (!active) {
    return null;
  }

  if (isDesktop && container) {
    return createPortal(
      <Box
        data-testid="dashboard-toolbar-actions"
        sx={{
          ...actionRowSx,
          flexWrap: 'nowrap',
          minWidth: 'max-content',
          height: '100%',
          ml: 'auto',
          order,
        }}
      >
        {children}
      </Box>,
      container,
    );
  }

  return (
    <Box
      data-testid="dashboard-toolbar-actions-fallback"
      sx={[
        {
          ...actionRowSx,
          flexWrap: 'wrap',
          mb: 1,
        },
        fallbackSx,
      ]}
    >
      {children}
    </Box>
  );
}

DashboardToolbarPortal.propTypes = {
  active: PropTypes.bool,
  order: PropTypes.number,
  children: PropTypes.node.isRequired,
  fallbackSx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};
